/** Origin for external-link checks during SSR (must match deployment URL if set). */
export function getSiteOrigin(): string {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return (import.meta.env.VITE_PUBLIC_SITE_ORIGIN as string | undefined) ?? '';
}

export const getIsLinkExternal = (link: string) => {
  if (link.startsWith('intent:')) {
    return true;
  }
  if (!link.startsWith('http://') && !link.startsWith('https://')) {
    return false;
  }
  const origin = getSiteOrigin();
  if (!origin) {
    return false;
  }
  return !link.startsWith(origin);
};
